import CustomCheckbox from "../../../../../../components/CustomCheckbox";
import SyntaxAnalysisSelection from "./SyntaxAnalysisSelection";
import SentenceTestSelection from "./SentenceTestSelection";
import ReadingSelection from "./ReadingSelection";
import FlowSelection from "./FlowSelection";

const AnalysisSelectionPage = ({
  allTypes,
  selectedTypes,
  setSelectedTypes,
}) => {
  const handleTypeClick = (type) => {
    setSelectedTypes((prev) => {
      if (prev.some((item) => item.key === type.key)) {
        return prev.filter((item) => item.key !== type.key);
      }
      if (type.key === "syntax_analysis") {
        return [
          ...prev,
          { key: type.key, value: type.value, level: { key: "", value: "" } },
        ];
      } else if (type.key === "sentence_test") {
        return [...prev, { key: type.key, value: type.value, options: [] }];
      } else if (type.key === "flow") {
        return [
          ...prev,
          { key: type.key, value: type.value, kor: true, eng: true },
        ];
      }
      return [...prev, { key: type.key, value: type.value }];
    });
  };

  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          marginBottom: "30px",
        }}
      >
        출제 유형 선택
      </div>
      <div style={{ fontSize: "16px", paddingBottom: "10px" }}>문제 유형</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        {allTypes.map((type) => (
          <div
            key={type.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              whiteSpace: "nowrap",
            }}
          >
            <CustomCheckbox
              checked={selectedTypes.some((item) => item.key === type.key)}
              onChange={() => handleTypeClick(type)}
              disabled={setSelectedTypes === undefined}
            />
            <div
              style={{
                fontSize: "16px",
                color: selectedTypes.some((item) => item.key === type.key)
                  ? "#000"
                  : "#737373",
              }}
            >
              {type.value}
            </div>
          </div>
        ))}
      </div>
      {selectedTypes.some((item) => item.key === "flow") && (
        <div
          style={{
            marginTop: "20px",
          }}
        >
          <FlowSelection
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        </div>
      )}
      {selectedTypes.some((item) => item.key === "reading") && (
        <div
          style={{
            marginTop: "20px",
          }}
        >
          <ReadingSelection
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        </div>
      )}
      {selectedTypes.some((item) => item.key === "syntax_analysis") && (
        <div
          style={{
            marginTop: "20px",
          }}
        >
          <SyntaxAnalysisSelection
            allTypes={allTypes}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        </div>
      )}
      {selectedTypes.some((item) => item.key === "sentence_test") && (
        <div
          style={{
            marginTop: "20px",
          }}
        >
          <SentenceTestSelection
            allTypes={allTypes}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        </div>
      )}
    </div>
  );
};

export default AnalysisSelectionPage;
